var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBanner = function SvgBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "banner_a",
    d: "M13 25h38a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H13a2 2 0 0 1-2-2V27a2 2 0 0 1 2-2zm0 2v10h38V27H13zm11 4a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2h-6zm0 4a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2H24zm-7-4v2h2v-2h-2zm0-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2z"
  })));
};
export default SvgBanner;